/**
 * Custom Surprise Cake scripts
 */
// Create "window.Shoppad.apps.infiniteoptions" object if it doesn't already exist
"Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { if (!o[x]) {o[x] ={};} return o[x] }, window);

document.addEventListener('page:loaded', function() {
    /**
     * Refresh cart on product removal
     */    
    let subtracted;
    $(document).on('click', '.js-qty__adjust--minus', function() {
        subtracted = true;
    })

    document.addEventListener('cart:updated', function(evt) {
        if(subtracted){
            location.reload();
            return false;
        }
    })

    /**
     * Sticky product image 
     */
    let stickWrap = $('.product_image_sticky');

    if( stickWrap.length ) {
        let stickEl   = stickWrap.children(":first"),
        stickStart, 
        stickHeight,
        stickEnd;

        calc();

        $(window).resize(function() {
            calc();
            if( $(window).width() >= 590 ) {
                stickEl.removeClass("Product_sticky");
            }
        })

        $(window).scroll(function() {
            stick();
        })

        function stick() {
            let scroll = $(window).scrollTop();
            if ( scroll > stickStart && scroll + stickHeight < stickEnd ){  
                stickEl.addClass("Product_sticky");
            } else {
                stickEl.removeClass("Product_sticky");
            }
        }

        //Use Infinite Options container to determine where product image should stop sticking.
        function calc() {
            swatches = $('.swatches');
            stickHeight = stickEl.height();
        
            if( $(window).width() < 590 ) {
                let stickHeightVal = stickHeight > 1 ? stickHeight + 'px' : '39vw';

                stickWrap.css('min-height', stickHeightVal );
            } else {
                stickWrap.css('min-height', '');
            }

            stickStart  = stickWrap.offset().top;
            stickEnd    = swatches.length ? swatches.offset().top + swatches.height() : stickStart + stickHeight + 1150;
        }

        // Define beforeReady callback
        window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {
            subscribe('appLoad', function(event) {
                Shoppad.$('.spb-productoptionswatchwrapper').contents().filter(function() {
                    return this.nodeType == 3;
                }).wrap('<span class="spb-swatchtooltip"></span>');

                let checkExist = setInterval(function() {
                    if ( swatches.length ) {
                        calc();
                        clearInterval(checkExist);
                    }
                }, 70); // check every 100ms
            })
        }
    }
})



/*-------new js-----------*/
/*
var	 myInterval  = setInterval(function(){		
  if($(document).find('.available-for-coding').length){
  if($(document).find('variant-swatch-king').length){
    
      clearInterval(myInterval);
       var currentloacation = window.location.href;
    
        $(document).find('variant-swatch-king .swatches-type-products > div').each(function(index){
        var labelFullText =   $(this).find('legend label .swatch-option-name').text();
          
           // labelFullText = labelFullText.split('.');
          //  $(this).find('legend label .swatch-option-name').text($.trim(labelFullText[1]));
          $(this).find('legend label .swatch-option-name').text($.trim(labelFullText));
           var appendHtml = $('<span class="variant-swatch-king-step">step '+labelFullText[0]+'</span>');
          // $(this).find('legend label.swatch-label-custom-image .swatch-option-name').before('<span class="variant-swatch-king-step">step '+labelFullText[0]+'</span>');
          // $(this).parents('.swatch-single').find('.swatch-option-name').before(appendHtml);
       })
    }	

  }
},1000)	
  
*/

$(document).on('change','[name="id"]',function(){

/*  

setTimeout(function(){
   if ($(document).find('body').hasClass('product-template-suprise-cake')){
        $(document).find('variant-swatch-king .swatches-type-products > div').each(function(index){
        var labelFullText =   $(this).find('legend label .swatch-option-name').text();
          if (labelFullText.indexOf(".") > -1) {
           // labelFullText = labelFullText.split('.');
                 //  $(this).find('legend label .swatch-option-name').text($.trim(labelFullText[1]));
          $(this).find('legend label .swatch-option-name').text($.trim(labelFullText));
           var appendHtml = $('<span class="variant-swatch-king-step">step '+labelFullText[0]+'</span>');
       //   $(this).find('legend label.swatch-label-custom-image .swatch-option-name').before('<span class="variant-swatch-king-step">step '+labelFullText[0]+'</span>');
          
          }// $(this).parents('.swatch-single').find('.swatch-option-name').before(appendHtml);
       })
    }
  },50)
  */
setTimeout(function(){
  var productPrice = $(document).find('.mobile_hide .product__price').text();
  $(document).find('.cake_collection_part .product__price').text(productPrice);
    },500)
})

var	 infinetOptionLoop  = setInterval(function(){	
  if($(document).find('.available-for-coding').length){
 if($(document).find('#infiniteoptions-container').length){
    clearInterval(infinetOptionLoop);
    
   setTimeout(function(){
     
     $(document).find('.butterflySurpriseUpload > label').after('<div class="butterflySurpriseUpload-image io-label-image"><img src=""></div>');
     $(document).find('.musicUpload > label').after('<div class="musicUpload-image io-label-image"><img src=""></div>');
     $(document).find('.videoUpload > label').after('<div class="videoUpload-image videoUploadVideo  io-label-image"><img src=""></div>');
     $(document).find('.customizeBoxUpload > label').after('<div class="customizeBoxUpload-image io-label-image"><img src=""></div>')
     $(document).find('.input_txt_img > label').after('<div class="inputUpload-image io-label-image"><img src=""></div>')
     $(document).find('.butterflySurpriseNumber  > label').after('<div class="butterflySurpriseNumber-image io-label-image"><img src=""></div>');
     $(document).find('.butterflyCustomizeUpload > label').after('<div class="butterflyCustomizeUpload-image io-label-image"><img src=""></div>');
     
     
     $(document).find('.butterflyCustomizeUpload > span  fieldset label [type="checkbox"]').after('<span class="checkbox-before"></span><span class="label-box"></span><span class="label-text"></span>')
     $(document).find('.butterflySurpriseUpload > span  fieldset label [type="checkbox"]').after('<span class="checkbox-before"></span><span class="label-box"></span><span class="label-text"></span>')
     $(document).find('.musicUpload > span  fieldset label [type="checkbox"]').after('<span class="checkbox-before"></span><span class="label-box"></span><span class="label-text"></span>');
     $(document).find('.videoUpload > span  fieldset label [type="checkbox"]').after('<span class="checkbox-before"></span><span class="label-box"></span><span class="label-text"></span>');
    
      $(document).find('.io-checkbox > span  fieldset label').each(function(){
        //  $(this).html(function(){ 
        //    return $(this).html().replace(optionText, ""); 
        // });
         var optionText =  $(this).text();
        // $(this).html($(this).html().split(""+optionText+"").join(""));
        // $(this).find('.label-text').html(optionText);
        // $(this).find('.label-text').before('<span class="checkbox-added">added!</span>');
      })
    
     // $(document).find('.videoUpload > span fieldset label').each(function(){
     //   var Self = $(this);
     //    var optionText =  $(this).text();
     //   // $(this).html($(this).html().split(""+optionText+"").join(""));
     //    $(this).find('.label-text').html(optionText);
     //    $(this).find('.label-text').before('<span class="checkbox-added">added!</span>');
     //  })
     
     $(document).find('form label').each(function(){
       var formUplodaryText = $(this).text();
       if(formUplodaryText.indexOf('Photo ') > -1){
         formUplodaryText = formUplodaryText.split(' ');
         $(this).append('<div class="formUplodary-field"><span class="formUplodary-photo"><span class="formUplodary-photo-inner"><sub>8 mb max</sub></span><span class="formUplodary-select-photo">select photos</span></div>')
        $(this).html(function(){ 
          // return $(this).html().replace("Panel", ""); 
        });
       }
     })
   $(document).find('form label').each(function(){
         var formUplodaryText = $(this).text();
       if($(this).hasClass('upload-video')){
         $(this).append('<div class="formUplodary-field"><span class="formUplodary-photo"><span class="formUplodary-photo-inner"><sub>8 mb max</sub></span><span class="formUplodary-select-photo">select video</span></div>') 
       $(this).html(function(){ 
          // return $(this).html().replace("Upload Video", ""); 
        });
       }
      });
     $(document).find('form label').each(function(){
         var formUplodaryText = $(this).text();
      var voiceSmall =  $(document).find('.voice_small_text').text();
       if($(this).hasClass('upload-voice')){
         $(this).append('<div class="formUplodary-field"><span class="formUplodary-photo"><span class="formUplodary-photo-inner"><sub>'+voiceSmall+'</sub></span><span class="formUplodary-select-photo">select voice</span></div>') 
       $(this).html(function(){ 
          // return $(this).html().replace("Upload Video", ""); 
        });
       }
      });
      $(document).find('.io-images-bulk span').each(function(){
       var ioImageSrc = $(this).text();
        var ioPostClass = $(this).data('image');
        $(document).find('.'+ioPostClass+' img').attr('src',ioImageSrc);
     })
   var custmizeCakeHeading =  $(document).find('.customize-cake-heading').text();
   if($(document).find('.butterfly_surprise_image').length){
     $(document).find('.butterflySurpriseUpload-image').show();
   }else{
     $(document).find('.butterflySurpriseUpload-image').hide();
   }
    var videoHtml = $(document).find('.video_image').html();
      $(document).find('.videoUploadVideo').html(videoHtml);
      if($(document).find('.surprise-cake-gift-cards').length){
           var total = $('.surprise-cake-gift-cards .spb-productoptionswatchwrapper').length;
            var count = 0;
           var indexForData = 3
            var newTotal = total - 3;
           total =  total - 1
            $(document).find('.surprise-cake-gift-cards .spb-productoptionswatchwrapper').each(function(index){
            $(this).find('input[type="radio"]').before('<div  class="cards-image"></div>');
            var cardImageData = $(this).find('.spb-productoptionswatch')[0].outerHTML;
            $(this).find('.cards-image').append(cardImageData);
            if(index > 0){
              if(total > index|| count == 2){
               if(count == 2){
               $(this).after('<div class="giftCardData'+index+' giftCardData"><div class="giftCardDataInner"></div></div>');
               }
                }else{
                  $(this).after('<div class="giftCardData'+index+' giftCardData"><div class="giftCardDataInner"></div></div>');
               }
                count = count + 1; 
                if(count == 3){
                 count = 0;
                }
              }
          })
         var count = 0;
         var indexForData = 3
         $(document).find('.surprise-cake-gift-cards .spb-productoptionswatchwrapper').each(function(index){
           
           if(index > 0){
          var giftCardValue = $(this).find('[type="radio"]').val();
          var giftCardPlace = $(this).find('.spb-productoptionswatch')
           if (giftCardValue.indexOf("®") > -1) {
              giftCardValue = giftCardValue.replace('®','')
              giftCardValue =  giftCardValue.replaceAll(' ','')
             $(document).find('.value-'+giftCardValue+'').insertAfter('.giftCardData'+indexForData+' .giftCardDataInner'); 
           }
      
            count = count + 1; 
          if(newTotal >  index ){
             
            if(count >= 3){
              count = 0;
              indexForData =  indexForData  + 3
            }
          }else{
            indexForData =  total
          }
        }
         })
      }
     setTimeout(function(){
      var cardOptionhtml =  $(document).find('.io-images-bulk .card-option-html').html()
      $(document).find('.gifts-card-label  .spb-label-tooltip  label').html(cardOptionhtml);
     },1000)
// $(document).find('#infiniteoptions-container .spb-select').append('<span class="select-drop-down-icon">▼</span>');
     var giftInfoText = $(document).find('.gift_information_text').text();
    $(document).find('.gift-message-to').before('<div class="gift-message-heading"><h4>'+giftInfoText+'</h4></div>');
     if($(document).find('#infiniteoptions-container:first-child').text() !=''){
       $(document).find('#infiniteoptions-container:first-child').before('<div class="custom-cake-option-heading"><h4>Personalize Your Surprise Cake!</h4></div>');
     }
    
    var custmizeCakeHeading =  $(document).find('.customize-cake-heading').text();
    $(document).find('.custom-cake-option-heading h4').text(custmizeCakeHeading);
     $(document).find('.gifts-card-label > span label input[type="radio"]').after('<span class="checkbox-before"></span>');
   },2500)

   $(document).on('change','[data-uploadery] input[type="file"]',function(){
     var filename = $(this).val().replace(/C:\\fakepath\\/i, '')
     if(filename != ''){
     if($(this).parents('[data-uploadery]').find('.file-uploaded-name').length){
       $(this).parents('[data-uploadery]').find('.file-uploaded-name').text(filename);
     }else{
       $(this).parents('[data-uploadery]').find('.formUplodary-photo').append('<span class="file-uploaded-name">'+filename+'</span>')
     }
     $(this).parents('[data-uploadery]').find('.formUplodary-select-photo').text('Uploaded');
     }else{
        $(this).parents('[data-uploadery]').find('.file-uploaded-name').text('');
      $(this).parents('[data-uploadery]').find('.formUplodary-select-photo').text('select photos');
     }
   })
  
   var selectBelowText = $(document).find('.select-below-text').text();
   $(document).find('.customizeBoxUpload>span .spb-select select').after('<span class="selectTextBelow">'+selectBelowText+'</span>');
   setTimeout(function(){
     $(document).find('.gifts-card-label>span label input[type="radio"]').prop("checked", false);
   },1500)
  
  $(document).on('change','.surprise-cake-gift-cards .gifts-card-label input[type="radio"]',function(){
    $(document).find('.gifts-card-label>span label input[type="radio"]').not(this).prop("checked", false);
  })
 
   $(document).on('change','.butterflySurpriseUpload.io-checkbox.customizeBoxAdd>span .spb-select select',function(){
     if($(document).find('.butterflySurpriseUpload-selected-data').length){
      $(document).find('.butterflySurpriseUpload-selected-data').remove();
     }
     $(document).find('.butterflySurpriseUpload').append('<div class="butterflySurpriseUpload-selected-data"></div>');
     var butterflySurpriseUploadProduct = $(this).find('option:selected').val();
     var butterflySurpriseAddedText  = $(document).find('.infinteOptionSelectText').find('.butterfly-added-text').text(); 
     var butterflySurpriseAddedEmoji  = $(document).find('.infinteOptionSelectText').find('.butterfly-emoji').text(); 
    
     
     if(butterflySurpriseUploadProduct.indexOf('Select') > -1 || butterflySurpriseUploadProduct.indexOf('No Butterfies') > -1){
       $(document).find('.butterflySurpriseUpload-selected-data').remove();
     }else{
       var selsectedHtml = '<span>'+butterflySurpriseAddedEmoji+' '+butterflySurpriseUploadProduct+' '+butterflySurpriseAddedText+'</span>'
       $(document).find('.butterflySurpriseUpload-selected-data').append(selsectedHtml);
     }

   })

     $(document).on('change','.butterflySurpriseNumber.io-checkbox.customizeBoxAdd>span .spb-select select',function(){
     if($(document).find('.butterflySurpriseNumber-selected-data').length){
      $(document).find('.butterflySurpriseNumber-selected-data').remove();
     }
     $(document).find('.butterflySurpriseNumber').append('<div class="butterflySurpriseNumber-selected-data"></div>');
     var butterflySurpriseNumberProduct = $(this).find('option:selected').val();
     var butterflyGiftAddedEmoji  = $(document).find('.infinteOptionSelectText').find('.number-added-text').text(); 
     var butterflyNumberAddedEmoji  = $(document).find('.infinteOptionSelectText').find('.gift-emoji').text(); 
    
     
     if(butterflySurpriseNumberProduct.indexOf('Select') > -1 || butterflySurpriseNumberProduct.indexOf('No Butterfies') > -1){
       $(document).find('.butterflySurpriseUpload-selected-data').remove();
     }else{
       var selsectedHtml = '<span>'+butterflyNumberAddedEmoji+' '+butterflySurpriseNumberProduct+' '+butterflyGiftAddedEmoji+'</span>'
       $(document).find('.butterflySurpriseNumber-selected-data').append(selsectedHtml);
     }

   })
   
      $(document).on('change','.musicUpload.io-checkbox.customizeBoxAdd>span .spb-select select',function(){
        if($(document).find('.musicUpload-selected-data').length){
         $(document).find('.musicUpload-selected-data').remove();
        }
         $(document).find('.musicUpload').append('<div class="musicUpload-selected-data"></div>');
      var musicUploadProduct = $(this).find('option:selected').val();
      var musicUploadAddedText  = $(document).find('.infinteOptionSelectText').find('.musicUpload-added-text').text(); 
      var musicUploadAddedEmoji  = $(document).find('.infinteOptionSelectText').find('.musicUpload-emoji').text(); 
     if(musicUploadProduct.indexOf('Select') > -1 || musicUploadProduct.indexOf('No Music') > -1 ){
     $(document).find('.musicUpload-selected-data').remove();

     }else{
    var selsectedHtml = '<span>'+musicUploadAddedEmoji+' '+musicUploadProduct+' '+musicUploadAddedText+'</span>'
       $(document).find('.musicUpload-selected-data').append(selsectedHtml);
     }
    if($(document).find('.gift-music').length){
      $(document).find('.gift-music').remove();
     }
    $(document).find('.musicUpload').append('<div class="gift-music"></div>');
      if(musicUploadProduct.indexOf('Halloween') > -1){
       var musicData =  $(document).find('.hell-music').html();
        $(document).find('.gift-music').html(musicData);
      }else if(musicUploadProduct.indexOf('Birthday') > -1){
       var musicData =   $(document).find('.hbm-music').html();
         $(document).find('.gift-music').html(musicData);
      }else if(musicUploadProduct.indexOf('Christmas') > -1){
       var musicData =  $(document).find('.chr-music').html();
         $(document).find('.gift-music').html(musicData);
      }else{
         $(document).find('.gift-music').remove();
      } 
   })
   $(document).on('tap mousedown','.giftCardData label',function(){
     if($(this).find('[type="radio"]').is(':checked')){
        setTimeout(function(){
          $('.giftCardData').find('[type="radio"]').prop("checked", false);
        },200);
     }
   })
   }}
},500)	

$(document).on('tap mousedown', '.spb-productoptionswatchwrapper',function(e){
  var self = $(this)
    if($(this).find('[type="radio"]').is(':checked')){
      setTimeout(function(){
        $('.surprise-cake-gift-cards .spb-productoptionswatchwrapper').find('[type="radio"]').prop( "checked", false );
        $('.surprise-cake-gift-cards .spb-productoptionswatchwrapper').find('[value="No Gift Card"]').parent("label").trigger('click');  
        self.removeClass('selected');
      },500);
    }else{
      $(document).find('.surprise-cake-gift-cards .spb-productoptionswatchwrapper').removeClass('selected');
      $(this).addClass('selected');  
    }
});

$(document).on('click','.select-drop-down-icon',function(){
 // $(this).parents('.spb-select').find('.spb-productdescfont').trigger('mousedown');

    var selectParent =  this.parentElement
 
 var selectElement =  selectParent.querySelector("select");
//  let clickEvent = new Event('click');
 selectElement.dispatchEvent(new Event('mousedown'));
})

$(document).on('click','.swatch-tool-tip',function(){
    $(this).parents('li').trigger('click');
})

$(document).on('change','.input_txt_img.io-checkbox>span .spb-productdescfont',function () {
  var select_opt = $(this).find('option:selected').val();
  if(select_opt == 'Add Text'){
    $('.input_txt.io-checkbox').addClass('active');
  } else {
    $('.input_txt.io-checkbox').removeClass('active');
  }

  $('.input_txt.io-checkbox input').on('keyup input',function() {
    var input_length = this.value.length;
    var input_count = 30 - input_length;
    console.log(input_count);
    if(this.value.length < 31) {
      $('.input_txt.io-checkbox .spb-helptext').empty();
      $('.input_txt.io-checkbox .spb-helptext').prepend(input_count + ' Characters Remaining');
    }
  });
});
$(document).ready(function () {
  setTimeout(function() {
    $(".sweeter_img_match").each(function() {
      var data_match = $(this).attr("data-match");
      var data_setimg = $(this).attr("data-setimg");
            
      $('.make_your_gift_option fieldset label input[value="'+data_match+'"]').closest("label").prepend('<img src="'+data_setimg+'">');
     

      var get_text = $('.make_your_gift_option fieldset label input[value="'+data_match+'"]').closest("label").text();
      var content = get_text.split("+");
      console.log(content);
//       var add_breake =  content[0]+'</br>'+content[1];
// $('.make_your_gift_option fieldset label input[value="'+data_match+'"]').closest("label").text('');
//       $('.make_your_gift_option fieldset label input[value="'+data_match+'"]').closest("label").append(add_breake);


      
    });

    /* Customize Box Code */
    // $(".customize_img_match").each(function() {
    //   var cust_match = $(this).attr("data-custmatch");
    //   var data_custimg = $(this).attr("data-custimg");
            
    //   $('.make_your_customize_option fieldset label input[value="'+cust_match+'"]').closest("label").prepend('<img src="'+data_custimg+'">');
     

    //   var get_cust = $('.make_your_customize_option fieldset label input[value="'+cust_match+'"]').closest("label").text();
    //   var content = get_cust.split("+");
    //   console.log(content);
      
    // });

    $(".customize_img_match").each(function() {
      var cust_match = $(this).attr("data-custmatch");
      var data_custimg = $(this).attr("data-custimg");
  
      // Prepend image to the label associated with the matching input value
      var targetLabel = $('.make_your_customize_option fieldset label input[value="'+cust_match+'"]').closest("label");
      targetLabel.prepend('<img src="'+data_custimg+'">');
  
      // Split label text content by "+" character and log to console
      var labelText = targetLabel.text();
      var content = labelText.split("+");
      console.log(content);
    });




    /* New Cstm Code for product handle copy-of-xyz */
    
     $(document).ready(function() {
      $('.make_new_customize_option span').each(function() {
        var fieldset = $('<fieldset></fieldset>');
        $(this).children().appendTo(fieldset);
         $(this).append(fieldset);        
      });
    });

    /* itg Code -D- */ 
    setTimeout(function() {
      $('.make_new_customize_option input[type="radio"]:checked').closest('label').addClass('active');
      $('.make_new_customize_option input[type="radio"]').on('change', function() {
        $('.make_new_customize_option label').removeClass('active');
        if ($(this).is(':checked')) {
          $(this).closest('label').addClass('active');
        }
      });
      $(".customize_img_match").each(function() {  
           var data_cstm = $(this).data("custmatch");
           var data_cstmimg = $(this).data("custimg");
      
          // Find the input with the matching value and add data-val attribute to its label
          var targetLabel = $('.make_new_customize_option fieldset label input[value="'+data_cstm+'"]').closest("label");
          if (targetLabel.length) {
            targetLabel.attr('data-val', data_cstm); // Add data-val attribute to the label
            targetLabel.append('<img src="'+data_cstmimg+'">'); // Prepend the image to the label
          }
        });
      $(".make_new_customize_option span").append("<button class='btn make_your_btn'>View All</button>");
      
    },2000);

    // $(document).ready(function() {
    //   $('.make_new_customize_option input[type="radio"]').prop('checked', false);  
    //   $('.make_new_customize_option input[type="radio"]').on('change', function() {
    //       $('.make_new_customize_option label').removeClass('active');          
    //       if ($(this).is(':checked')) {
    //           $(this).closest('label').addClass('active');
    //       }
    //   });
  
    //   $(".customize_img_match").each(function() {  
    //       var data_cstm = $(this).data("custmatch"); 
    //       var data_cstmimg = $(this).data("custimg"); 
  
    //       var targetLabel = $('.make_new_customize_option fieldset label input[value="'+data_cstm+'"]').closest("label");
    //       if (targetLabel.length) {
    //           targetLabel.attr('data-val', data_cstm); 
    //           targetLabel.append('<img src="'+data_cstmimg+'">');
    //       }
    //   });
  
    //   $(".make_new_customize_option span").append("<button class='btn make_your_btn'>View All</button>");
    // });




    
    
     $('.make_your_gift_option fieldset').prepend('<img src="'+window.teddyImage+'">');
     $('.make_your_gift_option.make_your_gift_number.show_drop_check .spb-label-tooltip').append($( ".teddy_img_block" ));

     $('.make_your_customize_option fieldset').prepend('<img src="'+window.customImage+'">');
     $('.make_your_customize_option.make_your_gift_number.show_drop_check .spb-label-tooltip').append($( ".teddy_img_block" ));

    $('.make_new_customize_option fieldset').prepend('<img src="'+window.customImage+'">');
    $('.make_new_customize_option.make_your_gift_flower.show_drop_check_flower .spb-label-tooltip').append($( ".cust_img_block" ));

  },1000);
  
  $(document).on('change','.make_your_gift_option fieldset label input',function () {
    // var checked_val = $(this).val();
    var checked_val = $(this).val();
    // console.log(checked_val);
    if ($('.spb-tooltip[title="'+checked_val+'"]').length > 0) {
      $(this).closest("label").addClass("active_checkremove");
    }
    if($(this.checked)){
      if($(this).closest("label").hasClass("active")){
        $(this).closest("label").removeClass("active");
      } else {
        $(this).closest("label").addClass("active");
      }
    }
  });

   $(document).on('change','.make_new_customize_option fieldset label input',function () {
    // var checked_val = $(this).val();
    var checked_val = $(this).val();
    if ($('.spb-tooltip[title="'+checked_val+'"]').length > 0) {
      $(this).closest("label").addClass("active_checkremove");
    }
    if($(this.checked)){
      if($(this).closest("label").hasClass("active")){
        $(this).closest("label").removeClass("active");
      } else {
        $(this).closest("label").addClass("active");
      }
    }
  });

  /* Customize Box Code */
// $(document).on('change', '.make_your_customize_option fieldset label input', function () {
//     var checked_val = $(this).val();
//     var hiddenInputValue = $('.make_your_customize_option fieldset input[type="hidden"]').val();
//     console.log(checked_val, hiddenInputValue);
//     $('.make_your_customize_option fieldset label input[type="checkbox"]').not(this).prop('checked', false);

//     // Deselect all checkboxes first
//     $('.make_your_customize_option fieldset label input').not(this).prop('checked', false).closest('label').removeClass('active active_checkremove');

//     // Toggle active class on the closest label
//     if ($(this).is(':checked')) {
//       $(this).closest('label').addClass('active');
//       console.log(this);
//       // Check if the tooltip exists and add active_checkremove class
//       if ($('.spb-tooltip[title="'+checked_val+'"]').length > 0) {
//         $(this).closest('label').addClass('active_checkremove');
//       }
//     } else {
//       $(this).closest('label').removeClass('active active_checkremove');
//     }
//   });
  
 /* Customize Box Code Only One Value shown */
  
  $(document).on('change', '.make_your_customize_option fieldset label input[type="checkbox"]', function () {
  // Deselect all checkboxes except the current one
  $('.make_your_customize_option fieldset label input[type="checkbox"]').not(this).prop('checked', false);

  // Toggle active class on the closest label
  if ($(this).is(':checked')) {
    // Remove 'active' class from all labels
    $('.make_your_customize_option fieldset label').removeClass('active');

    // Add 'active' class to the closest label
    $(this).closest('label').addClass('active');

    // Get the value of the checked checkbox
    var checked_val = $(this).val();
    console.log("Checked Value:", checked_val);

    // Push the checked value to the hidden input
    $('.make_your_customize_option fieldset input[type="hidden"]').val(checked_val);

    // Check if the tooltip exists and add 'active_checkremove' class
    if ($('.spb-tooltip[title="'+checked_val+'"]').length > 0) {
      $(this).closest('label').addClass('active_checkremove');
    }
  } else {
    // If unchecked, remove 'active' class and reset hidden input value
    $(this).closest('label').removeClass('active active_checkremove');
    $('.make_your_customize_option fieldset input[type="hidden"]').val('');
  }
});



  
  
  $(document).on('change','.show_drop_check fieldset label input:eq(1)',function () {
    var checked_val = $(this).val();
    if(this.checked){
      $('.spb-tooltip[title="'+checked_val+'"]').closest(".hidden_checked_content").addClass("show_in");
     // $('.spb-tooltip[title="'+checked_val+'"]').closest(".hidden_checked_content.show_in").find('span label:eq(0)').trigger('click');
      $(".hidden_number_drop.hidden_checked_content .spb-select select").attr("required",true);
    } else {
      $(".hidden_number_drop").find(".spb-select select").prop('selectedIndex',0)
      $('.spb-tooltip[title="'+checked_val+'"]').closest(".hidden_checked_content").removeClass("show_in");
  //    $(".hidden_flower_box").find("label.active input:checked").trigger("click");
      $(".hidden_number_drop.hidden_checked_content .spb-select select").attr("required",false);
    }
  });
  $(document).on('change','.show_drop_check_flower fieldset label input:eq(1)',function () {
    var checked_val = $(this).val();
   
    if(this.checked){
      $(document).find('.hidden_flower_box.make_your_gift_option.hidden_checked_content').removeClass('show_in ');
      $('.spb-tooltip[title="'+checked_val+'"]').closest(".hidden_checked_content").addClass("show_in center_ck");

       $('.spb-tooltip[title="'+checked_val+'"]').closest(".hidden_checked_content.show_in").find('span label:eq(0)').trigger('click');
      var checked = $(".hidden_flower_box fieldset label input:checked").length > 0;
      if (!checked){
        $(".hidden_flower_box fieldset label input").attr("required",true);
      }
    } else {
      $(".hidden_number_drop").find(".spb-select select").prop('selectedIndex',0)
      $('.spb-tooltip[title="'+checked_val+'"]').closest(".hidden_checked_content").removeClass("show_in");
      $(".hidden_flower_box.center_ck").find("label.active input:checked").trigger("click");
      $(".hidden_flower_box fieldset label input").attr("required",false);
    }
  });
  // $(document).on('change','.show_drop_check_flower fieldset label input:eq(0)',function () {
  //   var checked_val = $(this).val();
  //   if(this.checked){
  //     $(document).find('.hidden_flower_box.make_your_gift_option.hidden_checked_content').removeClass('show_in');
  //     $('.spb-tooltip[title="'+checked_val+'"]').closest(".hidden_checked_content").addClass("show_in left_arrow");
  //     var checked = $(".hidden_flower_box fieldset label input:checked").length > 0;

  //    $('.spb-tooltip[title="'+checked_val+'"]').closest(".hidden_checked_content.show_in").find('span label:eq(0)').trigger('click');
      
      
  //     if (!checked){
  //       $(".hidden_flower_box fieldset label input").attr("required",true);
  //     }
  //   } else {
  //     $(".hidden_number_drop").find(".spb-select select").prop('selectedIndex',0)
  //     $('.spb-tooltip[title="'+checked_val+'"]').closest(".hidden_checked_content").removeClass("show_in");
  //    $('.spb-tooltip[title="'+checked_val+'"]').closest(".hidden_checked_content.show_in label:eq(0)").trigger('click');
  //    $(".hidden_flower_box.left_arrow").find("label.active input:checked").trigger("click");
  //     $(".hidden_flower_box fieldset label input").attr("required",false);
  //   }
  // });

    setTimeout(function() {
      $(".surprise-cake-gift-cards").append("<button class='view_all_card_btn btn'>View All</button>");
      $(".make_your_customize_option span").append("<button class='btn make_your_btn'>View All</button>");
    },1000);

  $(document).on('change','.hidden_flower_box fieldset label input',function () {
    if(this.checked){
      $(".hidden_flower_box fieldset label input").attr("required",false);
    } else {
      $(".hidden_flower_box fieldset label input").attr("required",true);
    }
  });
  
  $(document).on('click','.view_all_card_btn',function () {
    $(this).toggleClass("active_");
    if($('.surprise-cake-gift-cards label.spb-productoptionswatchwrapper').hasClass("active")){
      $('.surprise-cake-gift-cards label.spb-productoptionswatchwrapper').removeClass("active selected");
      $('.surprise-cake-gift-cards .spb-productoptionswatchwrapper').find('[value="No Gift Card"]').parent("label").trigger('click');
      $(this).text("View All");
    } else {
      $('.surprise-cake-gift-cards label.spb-productoptionswatchwrapper').addClass("active");
      $(this).text("View Less");
    }
  });

  $(document).on('click','.sp-validate-overlay',function () {
    $(this).addClass('desable_ls');
  });

$(".product-single__form").submit(function(){
  $('.product-single__form button[name="add"]').addClass('desable_ls');
});
  
});